// extracted by mini-css-extract-plugin
export default {"pr-contact":"RUfJgE","pr-contact__two-items":"pF5_5D"};